module.exports = __webpack_public_path__ + "static/media/home.31dc4ceb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/home.svg
// module id = 206
// module chunks = 0